var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3333 8.66C14.9667 8.66 14.6667 8.96 14.6667 9.32667V12.6667C14.6667 13.7667 13.7667 14.6667 12.6667 14.6667H3.33333C2.23333 14.6667 1.33333 13.7667 1.33333 12.6667V3.33333C1.33333 2.23333 2.23333 1.33333 3.33333 1.33333H8C8.36667 1.33333 8.66667 1.03333 8.66667 0.666667C8.66667 0.3 8.36667 0 8 0H3.33333C1.49333 0 0 1.49333 0 3.33333V12.6667C0 14.5067 1.49333 16 3.33333 16H12.6667C14.5067 16 16 14.5067 16 12.6667V9.32667C16 8.96 15.7 8.66 15.3333 8.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.89478 7.16911V8.67633C5.89478 9.46583 6.5342 10.1053 7.3237 10.1053H8.83093C9.21589 10.1053 9.57475 9.95519 9.84227 9.68768L15.5841 3.94586C16.1387 3.38473 16.1387 2.47779 15.5841 1.92318L14.0769 0.415955C13.5157 -0.138652 12.6088 -0.138652 12.0542 0.415955L6.31236 6.15777C6.04485 6.42528 5.89478 6.79067 5.89478 7.16911ZM7.19973 7.16911C7.19973 7.13649 7.21278 7.10386 7.23888 7.07776L12.9807 1.33595C12.9807 1.33595 13.0394 1.2968 13.072 1.2968C13.1047 1.2968 13.1373 1.30985 13.1634 1.33595L14.6706 2.84318C14.7228 2.89537 14.7228 2.97367 14.6706 3.02587L8.9288 8.76768C8.9288 8.76768 8.87008 8.80683 8.83745 8.80683H7.33023C7.25846 8.80683 7.20626 8.74811 7.20626 8.68286V7.17563L7.19973 7.16911Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f8de090a06e01c2420139c420273f316.svg";
export { ForwardRef as ReactComponent };